import $ from 'jquery';
import breakpoints from './breakpoints';
import hash from './hash';
import scrollDirection from './scroll-direction';

const $window = $(window);
const $body = $('body');
const $header = $('#header');
const $quick_links = $('.quick-links');
const $placeholder = $quick_links.find('.fixed-placeholder');

function clickHandler(event) {
  event.preventDefault();

  const id = this.hash.substring(1);
  const $destinationElement = $( document.getElementById(id) );
  const offset = parseInt($body.css('padding-top')) + $header.height() + $quick_links.height();

  hash.update('#' + id);

  $('html, body').delay(10).animate({
    scrollTop: $destinationElement.offset().top - offset
  }, 700);
}

function isSticky() {
  if (breakpoints.min.bg.matches) {
    scrollHandler();
    $window.on('scroll', scrollHandler);
  } else {
    $window.off('scroll', scrollHandler);
    $quick_links.removeClass('fixed up down');
    $placeholder.removeAttr('style');
  }
}

function scrollHandler() {
  const top = $window.scrollTop() + $header.height() + parseInt($body.css('padding-top'));
  const sd = scrollDirection();

  if ($quick_links.offset().top <= top) {
    $placeholder.height($quick_links.height());
    $quick_links.addClass('fixed');

    switch(sd) {
      case 'up':
        $quick_links.removeClass('down').addClass('up');
        break;
      case 'down':
        $quick_links.removeClass('up').addClass('down');
        break;
    }
  } else {
    $quick_links.removeClass('fixed up down');
    $placeholder.removeAttr('style');
  }
}

export default () => {
  if ($quick_links.length) {
    isSticky();
    breakpoints.min.bg.addListener(isSticky);

    $quick_links.find('a').click(clickHandler);
  }
}
